import { FleetUser } from "./FleetUser";

export class UpdateFleetUserDialogData {
    fleetUser?: FleetUser;
    fleetKindList?: string[];
}